import { memoizeFunction } from '@agilepoint/utils-common';

export const isIndeterminate = memoizeFunction((type: 'indeterminate' | 'determinate') => type === 'indeterminate');

export const isDeterminate = memoizeFunction((type: 'indeterminate' | 'determinate') => type === 'determinate');
